import { graphql } from './client';

export interface MfaRequirement {
    required: boolean;
}

const QUERY = `
    query ViewerMfaRequirement {
        viewer {
            mfaRequired
        }
    }
`;

// Fails open: any failure or a null `viewer` answers « not required », so a transient error
// never walls the person off from `/account`, the very screen where a factor is registered.
export const fetchMfaRequirement = async (idToken: string): Promise<MfaRequirement> => {
    try {
        const payload = await graphql<{ viewer?: { mfaRequired?: boolean | null } | null }>(QUERY, undefined, idToken);
        if (payload.errors?.length) {
            return { required: false };
        }
        return { required: payload.data?.viewer?.mfaRequired === true };
    } catch {
        return { required: false };
    }
};
